// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const atualizarIndicacoesParceiros = async (data: any) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/indicacao-parceiro`;
    try {
      const response = await axios.put(URL, data, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
